module.exports = __webpack_public_path__ + "static/media/deposits.682bbf9b.svg";